export interface SlackInstallation {
  id: number;
  slack_team_id: string;
  slack_team_name: string | null;
  organization_id: number;
  installed_by: number | null;
  is_active: boolean;
  created_at: string | null;
}

export interface SlackInstallationStatus {
  installation: SlackInstallation | null;
  isOwner: boolean;
}

export const slackInstallationQueryKey = (workspaceId: number) => [
  "slack-installation",
  workspaceId,
];

export interface SlackLinkInfo {
  slackTeamName: string | null;
  organizationId: number;
  isMember: boolean;
  alreadyLinked: boolean;
}

export const slackLinkInfoQueryKey = (token: string) => ["slack-link-info", token];
